import zbztAVSDK from './zbzt-av-sdk/zbzt-av-sdk';
import {
  version,
  config,
  getApiCloudBaseUrl,
  USER_LOCATION,
} from './config/config';
import util from './util/util';
import dict from './util/dict';

import CHANNEL from './channel';

import dataReport from './network/dataReport';

import {
  getCloudData,
  changeSdkInRoom
} from './network/api';

import defaultApi from './default';
import NOTICE from './notice';
import { globalVariables } from './zbzt-av-sdk/global-variables';
import * as reporter from './util/reporter';
import { TalBeauty } from './tencent-webar';

// window.zegoHasPushFlow = 0

export let userAndDeviceStatusInfo = {
  microPhone: false,
  camera: false,
  isPushingFlow: false,
  //不看他
  // ignoreList : new Set()
};
let sdkConfig = config;
let sdk_status = -1;
let sdkRetryCount = 0;
const windowObjArr = [['zbzt_sdk_req_get_cloud_params', 'zbztAVSDK_init_params', 'zbztAVSDK_device_checker_init', 'zbzt_sdk_cloud_data'], ['zbztAVSDK_init_sdk_type', 'current_sdk_type']];

const pullingStatus = {};
let confId;

let mirrorStatus = null;
// 重试初始化
function retryInit(error, name = 'init', args, dealSDKMsg) {
  //通知业务层，初始化失败，重试
  sdkRetryCount++;
  sdk_status = -1;
  if (sdkRetryCount > 3) {
    sdkRetryCount = 0;
    NOTICE.sdkStatus({
      status: 'retry_stop'
    });
    try {
      // console.log('获取云控失败上报加入教室code1',window.zbzt_sdk_init_params);
      dataReport.joinRoomResult({
        code: '1',
        // cloud_api_response: JSON.stringify(window.zbzt_sdk_cloud_data),
        // cloud_api_response: window.zbzt_sdk_cloud_data,
        cloud_api_url: `${getApiCloudBaseUrl()}/rtccloud/class/init`
      });
    } catch(e) {
      defaultApi.writeLog('获取云控接口失败');
    }
  } else {
    NOTICE.sdkStatus({
      status: `retry_${name}`,
      count: sdkRetryCount
    });
    defaultApi.writeLog(`sdk action: retry_${name}, count: it's the 【${sdkRetryCount}】 retry， ${error} error`);
    if (name === 'init') {
      return zbztsdk.init(args, dealSDKMsg);
    }
    return zbztsdk.changeSDK(1);
  }
}


/**
 *  设备状态通知
 * @param {String} deviceType 'audio', 'video'
 * @param {Bollean} operation
 */
function sendDeviceStatus(deviceType, operation) {
  if (window.zbztAVSDK_init_params) {
    const initParams = window.zbzt_sdk_init_params;
    NOTICE.deviceStatus({
      userId: initParams.userId,
      userName: initParams.userName,
      role: initParams.role,
      //获取设备类型和状态对应的文案，返回给业务层
      deviceType: deviceType,
      deviceStatus: operation ? 'open' : 'closed'
    });
    //更新设备状态，摄像头，麦克风 开启/关闭
    CHANNEL.sendUpdateStreamDeviceStatus(Object.assign({}, initParams, {
      deviceType: dict.getDeviceTypeKey(deviceType),
      deviceStatus: dict.getDeviceStatusKey(operation ? 'open' : 'closed')
    }));
  } else {
    console.log('尚未初始化，无须设备状态同步');
  }
}
/**
 *
 * @param {String} userId
 * @param {String} status 流状态
 */
function noticeStreamStatus(userId, status) {
  NOTICE.streamStatus({
    userId,
    status
  });
  defaultApi.writeLog(`sdk stream status userId: ${JSON.stringify(userId)} ${status}`);
}

function generateStreamId(userId, groupId) {
  if (!window.zbzt_sdk_init_params) {
    console.log('缺少初始化参数，无法生成streamId');
  }
  const initParams = window.zbzt_sdk_init_params;
  if (!initParams) {
    return '';
  }
  // TODO 测试用
  // if (initParams.sdkName === 'talrtc') {
  //   initParams.institutionId = 'd46144';
  // }
  return util.getStreamId({
    ...initParams,
    userId,
    groupId
  });
}

function caculateDeatailArgs(baseArgs, cloudData) {
  try {
    const commonArgs = {
      userId: baseArgs.userId,
      streamId: util.getStreamId(baseArgs),
      userName: baseArgs.userName || '',
      sid: baseArgs.sid,
      role: baseArgs.role,
      roomId: baseArgs.roomId + '',
      confId: confId,
      userAvatar: baseArgs.userAvatar || '',
      userToken: baseArgs.userToken || '',
      devices: baseArgs.devices,
      env: baseArgs.env,
      businessLinesType: baseArgs.businessLinesType,
      institutionId: baseArgs.institutionId,
      //站立模式：0  / 坐立模式：1
      mode: baseArgs.mode,
      live_id: baseArgs.liveId,
      // 课堂模式，0=小组课/1=新小班
      classMode: +baseArgs.classMode,
      //数据上报班课类型
      liveType: +baseArgs.liveType,
      //是否开启转推功能
      isTurnPush: baseArgs.isTurnPush || false,
      // isSetAEC: baseArgs.isSetAEC || false,
    };

    //从云控返回值中获取直播相关配置
    const liveConfig = {
      //大画面视频采集码率（取值范围：40kb~2000kb）
      // captureBitrate: +cloudData.captureBitrate,
      //大画面视频采集帧率（取值范围：5~30）
      // captureFps: +cloudData.captureFps,
      //大画面视频编码分辨率
      encodedResolutionWidth: +cloudData.encodedResolution.split('*')[0],
      encodedResolutionHeight: +cloudData.encodedResolution.split('*')[1],
      // 预览画面视频采集码率（取值范围：40kb~300kb）
      encodeCaptureBitrate: +cloudData.encodedBitrate,
      encodeCaptureFps: +cloudData.encodedFps,
      // 预览画面视频采集帧率（取值范围：5~15）
      previewCaptureFps: +cloudData.previewFps,
      // 预览视频编码分辨率
      previewResolutionWidth: +cloudData.previewResolution.split('*')[0],
      previewResolutionHeight: +cloudData.previewResolution.split('*')[1],
      //rtc同屏分辨率
      screenSameResolutionWidth: cloudData.screenSameResolution ? +cloudData.screenSameResolution.split('*')[0] : 1280,
      screenSameResolutionHeight: cloudData.screenSameResolution ? +cloudData.screenSameResolution.split('*')[1] : 720,
      //rtc同屏帧率 码率
      screenSameFps: cloudData.screenSameFps ? +cloudData.screenSameFps : 15,
      screenSameBitrate: cloudData.screenSameBitrate ? +cloudData.screenSameBitrate : 512000,
      // 转推Rtmp地址
      recordUrl: cloudData.recordUrl,
      aecMode: cloudData.aecMode != null ? cloudData.aecMode : -1,
      noiseSuppressMode: cloudData.noiseSuppressMode != null ? cloudData.noiseSuppressMode : -1
    };

    const detailArgs = {
      talrtc: Object.assign({}, commonArgs, liveConfig, {
        appId: cloudData.appId,
        usersign: 'testsign',
        teacherId: baseArgs.teacherId,
      }),
      nertc: Object.assign({}, commonArgs, liveConfig, {
        appId: cloudData.appId,
        usersign: 'testsign',
        teacherId: baseArgs.teacherId,
      }),
      volcrtc: Object.assign({}, commonArgs, liveConfig, {
        appId: cloudData.appId,
        usersign: 'testsign',
        teacherId: baseArgs.teacherId,
      }),
      trtc: Object.assign({}, commonArgs, liveConfig, {
        appId: cloudData.appId,
        usersign: cloudData.txRtcKey,
      }),
      zego: Object.assign({}, commonArgs, liveConfig, {
        appId: parseInt(cloudData.appId)|| 2251703116,
        appSignature: cloudData.appKey|| 'uYsmfJ4F8ERzRNC4ug6lWB/vfU6ffg+/ETRF14vjzs4=',
        businessType: 0,
        nNetType: 1,
      })

    };
    reporter.base.institutionid = commonArgs.institutionId;
    reporter.base.appid = cloudData.appId;
    reporter.base.roomid = commonArgs.roomId;
    reporter.base.userid = commonArgs.userId;
    reporter.base.liveid = commonArgs.live_id;
    return detailArgs;
  } catch (error) {
    console.error(error);
  }
}

/**
 * SDK 方法
 */
const zbztsdk = {
  version: version,
  notice: null,
  // 打开监听log
  openListenerLog: false,
  //端上初始化时传的false
  autoChangeSdk: true,
  log_id:null,
  setConfig(options) {
    Object.assign(sdkConfig, options);
    Object.assign(this, options);
  },
  USER_LOCATION,
  deviceStatus: {},
  enableLog(enable = true) {
    defaultApi.writeLog(`sdk action: enableLog ${JSON.stringify(enable)}`);
    config.weblog = !!enable;
  },

  /**
   * 初始化美颜SDK
   * @param {Object} params
   * @param {string} params.licenseKey 
   * @param {string} params.appId 
   * @param {() => Promise<{ signature: string, timestamp: string}>} params.authFunc
   */
  initBeauty(params) {
    return TalBeauty.init(params);
  },
  uninitBeauty() {
    TalBeauty.uninit();
  },
  /**
   * 打开美颜，默认不用调用，sdk内部会自动打开
   */
  enableBeauty() {
    TalBeauty.getInstance().enable();
  },
  /**
   * 关闭美颜
   */
  disableBeauty() {
    TalBeauty.getInstance().disable();
  },
  /**
   * 设置美颜参数
   * @param {Object} options 
   * @param {number} options.whiten 美白 0-1
   * @param {number} options.dermabrasion 磨皮0-1
   * @param {number} options.lift 窄脸0-1
   * @param {number} options.shave 削脸0-1
   * @param {number} options.eye 大眼0-1
   * @param {number} options.chin 下巴0-1
   * @param {number} options.darkCircle 黑眼圈0-1
   * @param {number} options.nasolabialFolds 法令纹0-1
   * @param {number} options.cheekbone 颧骨0-1
   * @param {number} options.head 小头0-1
   * @param {number} options.eyeBrightness 亮眼0-1
   * @param {number} options.lip 嘴唇 -1 - 1
   * @param {number} options.forehead 发际线 0-1
   * @param {number} options.nose 鼻子 -1 - 1
   * @param {number} options.usm 清晰 0-1
   */
  setBeautify(options) {
    TalBeauty.getInstance().setBeautify(options);
  },

  /**
   * @typedef {Object} BeautyEffect
   * @property {string} id 特效id
   * @property {number} intensity 特效强度，默认1，范围0-1
   * @property {number} filterIntensity 单独控制特效中的滤镜强度，默认取intensity，范围0-1
   */
  /**
   * 设置特效
   * @param {BeautyEffect | Array<BeautyEffect>} effects 
   * @param {Function} callback 
   */
  setEffect(effects, callback) {
    TalBeauty.getInstance().setEffect(effects, callback);
  },
  /**
   * 设置Animoji表情或虚拟形象
   * @param {Object} params 
   * @param {'AR' | 'VR'} params.mode 模式
   * @param {string | undefined} params.effectId 透传effectId使用内置模型
   * @param {string | undefined} params.url 透传url使用自定义模型
   * @param {string | undefined} params.backgroundUrl 背景图片链接，仅在VR模式下生效
   */
  setAvatar(params) {
    TalBeauty.getInstance().setAvatar(params);
  },
  /**
   * 设置背景
   * @param {Object} options 
   * @param {'image' | 'blur' | 'transparent'} options.type 背景类型
   * @param {string | undefined} options.src 背景图片地址,仅在type为image时有效
   */
  setBackground(options) {
    TalBeauty.getInstance().setBackground(options);
  },
  /**
   * 切换背景分割模型
   * @param {0 | 1 | 2} level 
   */
  setSegmentationLevel(level) {
    TalBeauty.getInstance().setSegmentationLevel(level);
  },
  /**
   * 设置滤镜
   * @param {string} id 滤镜ID
   * @param {number} intensity 滤镜强度，范围0-1
   * @param {Function} callback 设置成功回调
   */
  setFilter(id, intensity, callback) {
    TalBeauty.getInstance().setFilter(id, intensity, callback);
  },
  /**
   * 
   * @param {Object} params 
   * @param {number | undefined} params.PageNumber 页码
   * @param {number | undefined} params.PageSize 页面大小
   * @param {string | undefined} params.Name 名称
   * @param {Array<string> | undefined} params.Label 标签
   * @param {'Custom' | 'Preset'} params.Type 类型
   * @returns
   */
  getEffectList(params) {
    return TalBeauty.getInstance().getEffectList(params);
  },
  /**
   * 
   * @param {'AR' | 'VR'} type 
   * @returns 
   */
  getAvatarList(type) {
    return TalBeauty.getInstance().getAvatarList(type);
  },
  /**
   * 
   * @param {string} effectId 
   * @returns 
   */
  getEffect(effectId) {
    return TalBeauty.getInstance().getEffect(effectId);
  },
  getCommonFilter() {
    return TalBeauty.getInstance().getCommonFilter();
  },
  async deviceCheckerInit(cb) {
    if (typeof cb !== 'function') {
      defaultApi.writeLog(`sdk action: deviceCheckerInit need a callback function, but received: ${typeof cb}`, null, 'error');
      throw new Error('deviceCheckerInit need a callback function');
    }
    NOTICE.setEmitter({
      emit: cb.bind(zbztsdk)
    });
    window.zbztAVSDK_init_sdk_type = null;
  },
  stopCheckDevice() {
    defaultApi.writeLog('sdk action: stopCheckDevice');
  },
  async init(args, dealSDKMsg) {
    if (sdk_status !== -1) {
      console.log('not allow init');
      dealSDKMsg({
        type: 'error',
        data: {
          message: 'should not start init before init finished'
        }
      });
      return;
    }
    reporter.userFunc('init', args);
    defaultApi.writeLog(`sdk action: init zbzt_live_sdk_version : ${version}`);
    defaultApi.writeLog(`sdk action: init args : ${JSON.stringify(args)}`);
    try {
      let argsCopy = JSON.parse(JSON.stringify(args));
      delete argsCopy.cloudData;
      defaultApi.writeLog(`sdk action: init_argsCopy_args : ${JSON.stringify(argsCopy)}`);
    } catch (e) {};
    this.log_id = 0;
    sdk_status = 0;
    // 初始化参数存入共享
    window.zbzt_sdk_init_params = args;
    // 设置confId
    confId = util.getConfId(args.institutionId, args.roomId);
    //使用初始化传入的 env， isHttps 参数
    Object.assign(sdkConfig, args);

    NOTICE.setEmitter({
      emit: dealSDKMsg.bind(zbztsdk)
    });
    // zbztsdk.notice = dealSDKMsg;

    const reqParam = {
      clientType: 'web',
      roomType: 7,
      institutionId: args.institutionId + '',
      roomId: args.roomId + '',
      userType: args.role,
      userId: args.userId + '',
      teacherId: args.teacherId + ''
    };
    window.zbzt_sdk_req_get_cloud_params = reqParam;
    let cloudData;
    if (args.cloudData && args.cloudData.sdkName && args.cloudData.encodedResolution && args.cloudData.previewResolution) {
      cloudData = args.cloudData;
    } else {
      defaultApi.writeLog(`sdk_init: getCloudData reqParam : ${JSON.stringify(reqParam)}`);
      let cloudResponse;
      try {
        cloudResponse = await getCloudData(reqParam);
      } catch (error) {
        return retryInit('getCloudData', 'init', args, dealSDKMsg);
      }
      defaultApi.writeLog(`sdk_init: cloudResponse : ${JSON.stringify(cloudResponse)}`);
      if (cloudResponse.code === 0 && cloudResponse.data) {
        cloudData = cloudResponse.data;
      } else {
        defaultApi.writeLog(`sdk_init: get cloudResponse error: ${JSON.stringify(cloudResponse)}`);
        return false;
      }
    }
    defaultApi.writeLog(`sdk_init: cloudData : ${JSON.stringify(cloudData)}`);
    window.zbzt_sdk_cloud_data = cloudData;
    const detailArgs = caculateDeatailArgs(args, cloudData);

    let sdk_type = cloudData.sdkName;
    // let sdk_type = 'zego';
    Object.assign(window.zbzt_sdk_init_params, cloudData);
    //通知业务层，初始化完成
    NOTICE.sdkStatus({
      sdk_type,
      status: 'before_init'
    });
    defaultApi.writeLog(`sdk status : before_init , sdk_type : ${sdk_type}`);
    const real_sdk_type = await zbztAVSDK.init(sdk_type, detailArgs);
    try {
      // dataReport.joinRoom({initParams: JSON.stringify(args)});
      dataReport.joinRoom({initParams: args});
    } catch (e) {};
    defaultApi.writeLog(`sdk status : init_finished  , sdk_type : ${sdk_type}`);
    //通知业务层，初始化完成
    NOTICE.sdkStatus({
      sdk_type,
      status: 'init_finished',
      real_sdk_type
    });
    try{
      dataReport.initFinished({code:0});
    }catch (e){ }
    sdk_status = 1;
    sdkRetryCount = 0;

    // 缓存初始化信息
    windowObjArr[0].forEach(item => {
      if (window[item] !== undefined) {
        localStorage.setItem(item, JSON.stringify(window[item]));
      }
    });
    windowObjArr[1].forEach(item => {
      if (window[item] !== undefined) {
        localStorage.setItem(item, window[item]);
      }
    });

    //进入信道房间
    // enterChannelRoom({...args, chatUrl: cloudData.chatUrl}, dealSDKMsg);
    // sendInitChannelMsg(args);
    CHANNEL.joinRoom({...args, chatUrl: cloudData.chatUrl, guid: window.zbzt_sdk_init_params.guid}, dealSDKMsg, cloudData.chatType);
  },

  // 恢复sdk
  async recoverSdk(args, dealSDKMsg) {
    defaultApi.writeLog(`sdk action : recoverSdk , args : ${JSON.stringify(args)}`);
    // 恢复全局变量
    windowObjArr[0].forEach(item => {
      const obj = localStorage.getItem(item);
      if (obj && obj.indexOf('{') > -1)  {
        try {
          window[item] = JSON.parse(obj);
        } catch (error) {
        }
      }
    });
    let cloudData;
    if (args.cloudData) {
      cloudData = args.cloudData;
    } else {
      try {
        cloudData = JSON.parse(localStorage.getItem('zbzt_sdk_cloud_data'));
      } catch (error) {
      }
    }
    windowObjArr[1].forEach(item => {
      window[item] = localStorage.getItem(item);
    });
    window.zbzt_sdk_init_params = args;

    defaultApi.writeLog('sdk action : recoverSdk , set window params finished');

    // try {
    //   await getLogAddress();
    //   await getAndSetInitParams({institutionId: args.institutionId, userId: args.userId});
    // } catch (error) {
    //   return retryInit('getAndSetInitParams', 'init', args, dealSDKMsg);
    // }

    //使用初始化传入的 env， isHttps 参数
    Object.assign(sdkConfig, args);

    zbztsdk.notice = dealSDKMsg;

    const detailArgs = caculateDeatailArgs(args, cloudData);

    await zbztAVSDK.recoverSdk(detailArgs);

    sdk_status = 1;

    //通知业务层，初始化完成
    NOTICE.sdkStatus({
      sdk_type: window.zbztAVSDK_init_sdk_type,
      status: 'init_finished'
    });

    defaultApi.writeLog('sdk action : recoverSdk finished');

    //进入信道房间
    // enterChannelRoom({...args, chatUrl: cloudData.chatUrl}, dealSDKMsg);
    // sendInitChannelMsg(args);
    CHANNEL.joinRoom({...args, chatUrl: cloudData.chatUrl}, dealSDKMsg, cloudData.chatType);
  },

  // 接收到信道消息，进行切换SDK操作
  // from 0:云控 1:重试 2: 上层调用
  async changeSDK(from = 0) {
    if (!window.zbzt_sdk_init_params || !window.zbzt_sdk_req_get_cloud_params) {
      console.log('缺少初始化参数，无法切换SDK');
      return;
    }
    //重试(2)不走下一步，否则会陷入死循环,如果是reJoin(1)来的,自动走切sdk逻辑,不触发start_sdk_change回调直接切
    if (from < 1)  {
      // 通知业务层，切换之前(授课业务逻辑需要，比如老师主动调切sdk,云控走的切sdk全部由老师主动切，修复连麦崩溃)
      NOTICE.sdkStatus({
        sdk_type: window.zbztAVSDK_init_sdk_type,
        status: 'start_sdk_change'
      });
    }
    defaultApi.writeLog('sdk status : start_sdk_change');
    if (from === 0 && !this.autoChangeSdk) {
      return;
    }
    const initParams = window.zbzt_sdk_init_params;
    let nowSdk = window.zbztAVSDK_init_sdk_type;
    let cloudData;
    //请求云控获取更新后的SDK配置相关信息
    let cloudResponse;
    try {
      cloudResponse = await getCloudData(window.zbzt_sdk_req_get_cloud_params);
    } catch (error)
    {
      defaultApi.writeLog(`changeSDK: getCloudData error ${JSON.stringify(error)}`);
      return retryInit('getCloudData', 'changeSDK');
    };
    cloudData = cloudResponse.data;

    if (cloudData) {
      const changeSDKParam = caculateDeatailArgs(initParams, cloudData);
      const sdk_type = cloudData.sdkName;

      window.zbztAVSDK_init_params = changeSDKParam;

      if (window.zbztAVSDK_init_sdk_type === sdk_type && sdk_type !== 'talrtc') {
        defaultApi.writeLog(`sdk: change sdk action , target is the same as local , will not change sdk to ${sdk_type}`);
        window.target_sdk_type = null;
        return;
      } else {
        window.target_sdk_type = sdk_type;
        defaultApi.writeLog(`sdk action: changeSDK to  sdk_type : ${sdk_type}, sdk status : start_change `);
      }

      // 通知业务层，切换之前
      NOTICE.sdkStatus({
        sdk_type: window.zbztAVSDK_init_sdk_type,
        target_sdk_type: sdk_type,
        status: 'before_sdk_change'
      });
      defaultApi.writeLog(`sdk status : before_sdk_change  to sdk_type : ${sdk_type}`);

      sdk_status = 0;

      let real_sdk_type;
      try {
        CHANNEL.sendRemoveStream(window.zbzt_sdk_init_params);
        CHANNEL.sendLeave(window.zbzt_sdk_init_params);
        real_sdk_type = await zbztAVSDK.changeSDK({
          sdk_type
        });
      } catch (error) {
        defaultApi.writeLog(`changeSDK error : ${JSON.stringify(error)}`);
        window.target_sdk_type = null;
      }

      // if (mirrorStatus !== null) {
      //   // 如果之前有镜像，切sdk之后，重新设置镜像
      //   await zbztAVSDK.setMirrorStatus(mirrorStatus);
      // }

      try {
        dataReport.sdkChange({
          from: nowSdk,
          to: sdk_type
        });
      } catch (e){};

      Object.entries(pullingStatus).forEach(([streamId, status]) => {
        pullingStatus[streamId] = false;
      });
      sdkRetryCount = 0;
      sdk_status = 1;
      window.target_sdk_type = null;
      // 通知业务层，切换完成
      NOTICE.sdkStatus({
        sdk_type,
        status: 'sdk_changed',
        real_sdk_type,
      });
      defaultApi.writeLog(`sdk status : sdk_changed  , sdk_type : ${sdk_type}, real_sdk_type : ${real_sdk_type}`);

      //切换SDK 完成后，先发送 join消息
      CHANNEL.sendJoin(initParams);

      // 打开本地摄像头, 并开始推流后, 老师视频和麦克风状态变为'开启', 即true
      await zbztsdk.openOrCloseCamera(userAndDeviceStatusInfo.camera);
      await zbztsdk.openOrCloseMicrophone(userAndDeviceStatusInfo.microPhone);

      if (userAndDeviceStatusInfo.isPushingFlow) {
        await zbztsdk.startPushFlow();
      }

      if (globalVariables.localPreviewDomId) {
        const videoSrc = await zbztsdk.getOrLocateVideo({
          isLocal: true,
          domId: globalVariables.localPreviewDomId,
          streamId: globalVariables.localStreamId
        });
        // NOTICE.updateLocalPreview({
        //   videoSrc: videoSrc
        // });
        defaultApi.writeLog(`sdk update_local_preview  , videoSrc : ${videoSrc} `);
        // }
      }

    }
  },
  changeGroup(groupId, channelToken) {
    return this.changeRoom(groupId, channelToken);
  },

  //alias changeGroup
  async changeRoom(roomId, channelToken) {
    if (!channelToken) {
      console.warn('changeRoom param: channelToken is required !');
      defaultApi.writeLog('changeRoom param: channelToken is required !');
      return;
    }

    defaultApi.writeLog(`sdk action : changeRoom to  roomId : ${roomId}`);

    //业务层停止所有拉流
    window.zbzt_sdk_init_params.roomId = roomId;
    const initParams = window.zbzt_sdk_init_params;

    // 通知业务层，room 切换之前
    zbztsdk.notice({
      type: 'sdk_status',
      data: {
        sdk_type: window.zbztAVSDK_init_sdk_type,
        target_room_id: roomId,
        status: 'before_room_change'
      }
    });
    defaultApi.writeLog(`sdk status : before_room_change to roomId ${roomId}`);
    //广播 leave 消息
    CHANNEL.sendLeave(initParams);
    //断开信道
    CHANNEL.leaveRoom(initParams);
    defaultApi.writeLog('channle status : leave channel room invoked');
    //退出当前流媒体房间
    await zbztAVSDK.leaveRoom();


    //获取新小组的云控数据
    let reqParam = {
      clientType: 'pc',
      roomType: 7,
      institutionId: initParams.institutionId + '',
      roomId: initParams.roomId + '',
      userType: initParams.role,
      userId: initParams.userId + '',
      teacherId: initParams.teacherId + ''
    };
    reqParam.sign = util.getVerifySign(reqParam);
    reqParam.main = 2;
    //暂存请求云控所需参数，为切换SDK作预备
    window.zbzt_sdk_req_get_cloud_params = reqParam;
    const cloudResponse = await getCloudData(window.zbzt_sdk_req_get_cloud_params);
    const cloudData = cloudResponse.data;
    const sdk_type = cloudData.sdkName;
    //SDK重新初始化
    const detailArgs = caculateDeatailArgs(initParams, cloudData);
    await zbztAVSDK.init(sdk_type, detailArgs);

    //重新进入信道
    initParams.channelToken = channelToken;
    // enterChannelRoom({...initParams, chatUrl: cloudData.chatUrl});
    defaultApi.writeLog('channle status : enter channel room invoked');
    // sendInitChannelMsg(initParams);
    CHANNEL.joinRoom({...args, chatUrl: cloudData.chatUrl}, dealSDKMsg, cloudData.chatType);

    // 通知业务层，room 切换之前
    zbztsdk.notice({
      type: 'sdk_status',
      data: {
        sdk_type: window.zbztAVSDK_init_sdk_type,
        room_id: roomId,
        status: 'room_changed'
      }
    });
    defaultApi.writeLog(`sdk status : room_changed ,roomId ${roomId}`);

  },
  async setCameraDevice(deviceId) {
    defaultApi.writeLog(`sdk action : setCameraDevice, deviceId ${deviceId}`);
    reporter.userFunc('setCameraDevice', deviceId);
    await zbztAVSDK.setCameraDevice(deviceId,'client');
  },

  async getCameraDeviceList() {
    defaultApi.writeLog('sdk action : getCameraDeviceList ');
    reporter.userFunc('getCameraDeviceList');
    const devices = await zbztAVSDK.getCameraDeviceList();
    defaultApi.writeLog(`sdk action : getCameraDeviceList result ${JSON.stringify(devices)}`);
    reporter.userFunc('getCameraDeviceList', devices);
    return devices;
  },

  async openOrCloseCamera(operation) {
    defaultApi.writeLog(`sdk action : openOrCloseCamera ${operation} --start`);
    reporter.userFunc('openOrCloseCamera', operation);
    userAndDeviceStatusInfo.camera = operation;
    //记录摄像头状态，用作推流类型上报，是否推视频
    this.deviceStatus.camera = operation;
    try {
      await zbztAVSDK.openOrCloseCamera(operation);
    } catch (error) {
      defaultApi.writeLog(`sdk action : openOrCloseCamera ${error}`, null, 'error');
      if (operation) {
        NOTICE.openCameraError(error);
      }
      return;
    }
    try {
      dataReport.deviceChange({
        device_type: 1,
        code: operation? 1 : 0,
        device_name: window.zbztAVSDK_device_checker_init.camera.name,
        device_id: window.zbztAVSDK_device_checker_init.camera.use
      });
    } catch (e){};
    sdk_status === 1 && sendDeviceStatus('video', operation);
    defaultApi.writeLog(`sdk action : openOrCloseCamera ${operation} --end`);
  },

  //推不推画面
  async setPushStreamVideo(operation) {
    await zbztAVSDK.setPushStreamVideo(operation);
    defaultApi.writeLog(`sdk action : setPushStreamVideo  ${operation} `);
  },

  //看或不看指定用户的视频
  async setVideoMute(userId, operation, groupId) {
    defaultApi.writeLog(`sdk action : setVideoMute userId ${userId}, groupId ${groupId}, operation ${operation}, streamId ${streamId}`);
    reporter.userFunc('setVideoMute', {userId, operation, groupId});
    const streamId = generateStreamId(userId, groupId);
    await zbztAVSDK.setVideoMute(streamId, operation);
  },

  async getOrLocateVideo(args) {
    defaultApi.writeLog(`sdk action : getOrLocateVideo --start args : ${JSON.stringify(args)}`);
    reporter.userFunc('getOrLocateVideo', args);
    const videoSrc = await zbztAVSDK.getOrLocateVideo({
      domId: args.domId,
      isLocal: args.isLocal,
      streamId: args.streamId || (args.userId && generateStreamId(args.userId, args.groupId)),
    });
    defaultApi.writeLog(`sdk getOrLocateVideo successfully, videoSrc : ${videoSrc} `);
    return videoSrc;
  },

  async restartCaptureScreen() {
    defaultApi.writeLog('sdk action : restartCaptureScreen');
    reporter.userFunc('restartCaptureScreen');
    await zbztAVSDK.restartCaptureScreen();
  },

  /**
   * 获取屏幕共享类型
   * @returns 
   */
  getScreenType() {
    defaultApi.writeLog('sdk action : getScreenType');
    const type = zbztAVSDK.getScreenType();
    defaultApi.writeLog(`sdk action : getScreenType result : ${type}`);
    return type;
  },

  async deviceCheckerPreview(args) {
    defaultApi.writeLog(`sdk action : deviceCheckerPreview --start args : ${JSON.stringify(args)}`);
    reporter.userFunc('deviceCheckerPreview', args);
    const streamId = args.streamId || (args.userId && generateStreamId(args.userId, args.groupId));
    await zbztAVSDK.startDeviceCheckerPreview(streamId, args.domId);
  },

  async stopDeviceCheckerPreview(args) {
    defaultApi.writeLog(`sdk action : stopDeviceCheckerPreview --start args : ${JSON.stringify(args)}`);
    reporter.userFunc('stopDeviceCheckerPreview', args);
    await zbztAVSDK.stopDeviceCheckerPreview();
  },
  async linkMicReport(args) {
    defaultApi.writeLog(`sdk action : linkMicReport  args : ${JSON.stringify(args)}`);
    const {name, pull_uid, trace_id} = args;
    let pull_uid1 = [];
    pull_uid.forEach( item => {
      pull_uid1.push(item+'');
    });
    if (dataReport.hasOwnProperty(name)) {
      dataReport[name]({pull_uid:pull_uid1,trace_id});
    };
  },

  /**
   * 开始推流
   * @param {string} streamid 流唯一标识
   * @param {0 | 1} idx 0: 启动摄像头 1: 启动屏幕共享
   * @returns 
   */
  async startPushFlow(streamid, idx) {
    defaultApi.writeLog(`sdk action : startPushFlow streamId:${streamid} idx: ${idx}`);
    reporter.userFunc('startPushFlow', {streamid, idx});
    userAndDeviceStatusInfo.isPushingFlow = true;
    try {
      // dataReport.startPublish({publish_streamid:window.zbztAVSDK_init_params.rtc.streamId});
      streamid&&idx ? dataReport.startPublish({publish_rtc_streamid:streamid}) : dataReport.startPublish() ;
    } catch (e) {};
    await zbztAVSDK.startPushFlow(streamid, idx);
    // 不重新推流此情况不适用，推流状态跟着设备开关情况改变,以下仅用作数据上报
    // console.log('push_type000',this.deviceStatus.camera,this.deviceStatus.microphone);
    if(this.deviceStatus.camera && this.deviceStatus.microphone) {
      this.deviceStatus.stream_type = 'both';
    } else if(!this.deviceStatus.camera && this.deviceStatus.microphone) {
      this.deviceStatus.stream_type = 'audio';
    } else if(this.deviceStatus.camera && !this.deviceStatus.microphone) {
      this.deviceStatus.stream_type = 'video';
    } else {
      this.deviceStatus.stream_type = 'none';
    }
    const initParams = window.zbzt_sdk_init_params;
    //rtc同屏流不走信道 !1
    if(!idx) {
      CHANNEL.sendAddStream(initParams);
    }
  },

  async stopPushFlow(idx, streamid) {
    defaultApi.writeLog(`sdk action : stopPushFlow streamid:${streamid} idx:${idx}`);
    reporter.userFunc('stopPushFlow', {idx, streamid});
    userAndDeviceStatusInfo.isPushingFlow = false;
    await zbztAVSDK.stopPushFlow(idx, streamid);
    try {
      streamid && idx ? dataReport.stopPublish({ stop_rtc_streamid: streamid }) : dataReport.stopPublish();
      // dataReport.stopPublish({});
    } catch (error) { };
    if(window.zbzt_sdk_init_params.isTurnPush) {
      zbztAVSDK.turnPush('stop');
    };
    if(!idx) {
      CHANNEL.sendRemoveStream(window.zbzt_sdk_init_params);
    }
  },

  async initPullFlow(args) {
    defaultApi.writeLog(`sdk action : initPullFlow ,${JSON.stringify(args)}`);
    reporter.userFunc('initPullFlow', args);
    const streamId = args.streamId || generateStreamId(args.userId, args.groupId);

    if (pullingStatus[streamId]) {
      defaultApi.writeLog(`sdk action : initPullFlow - pulling, streamId : ${streamId}`);
      reporter.userFunc('initPullFlow - pulling', args);
      return;
    };
    pullingStatus[streamId] = true;
    let {mute, audioOnly} = args;
    let streamType = 'none';

    if(mute && audioOnly) {
      streamType = 'none';
    } else if (mute && !audioOnly) {
      streamType = 'video';
    } else if (!mute && audioOnly) {
      streamType = 'audio';
    } else {
      streamType = 'both';
    };
    const result = zbztAVSDK.initPullFlow({
      ...args,
      streamId
    });
    // defaultApi.writeLog(`sdk action : initPullFlow——result ,${JSON.stringify(result)}`);
    try {
      dataReport.startPull({pull_uid: args.userId || util.getUidByStreamId(streamId), pull_streamid: streamId, stream_type: streamType});
    } catch (e) {};
    return result.videoSrc
      .then(({videoSrc, playerId}) => {
        defaultApi.writeLog(`sdk initPullFlow ${JSON.stringify(args)}, streamId : ${streamId}, result :${result.sdk_type}: ${videoSrc} type:${streamType} playerId:${playerId}`);
        if (args.needPlayerId) {
          return {
            videoSrc,
            playerId,
            streamId,
            ...args
          };
        }
        return videoSrc;
      })
      .finally(() => {
        pullingStatus[streamId] = false;
      });
  },

  async startPullFlow(userId, groupId) {
    reporter.userFunc('startPullFlow', {userId, groupId});
    if (typeof userId !== 'number' && typeof userId !== 'string') {
      defaultApi.writeLog(`sdk action : startPullFlow ,userId : ${JSON.stringify(userId)}, param error`);
      return;
    } else {
      defaultApi.writeLog(`sdk action : startPullFlow ,userId : ${JSON.stringify(userId)}, begin`);
    }
    const streamId = generateStreamId(userId, groupId);
    await zbztAVSDK.startPullFlow(streamId);
    // userAndDeviceStatusInfo.ignoreList.delete(userId)
    noticeStreamStatus(userId, 'stream_recover');
    defaultApi.writeLog(`sdk action : startPullFlow ，userId ${userId}, notice: stream_recover`);
  },

  async stopPullFlow(userId, groupId, recovery, streamid) {
    reporter.userFunc('stopPullFlow', {userId, groupId, streamid});
    // const {userId, groupId, recovery, streamid} = args;
    if (typeof userId !== 'number' && typeof userId !== 'string') {
      defaultApi.writeLog(`sdk action : stopPullFlow ,userId : ${userId}, groupId: ${groupId}, param error`);
      return;
    } else {
      defaultApi.writeLog(`sdk action : stopPullFlow ,userId : ${userId}, groupId: ${groupId}, begin`);
    }
    const streamId = streamid || generateStreamId(userId, groupId);
    await zbztAVSDK.stopPullFlow(streamId, recovery);
    try {
      dataReport.stopPull({pull_uid:userId,pull_streamid:streamId});
    } catch (e) {};
    noticeStreamStatus(userId, 'stream_stopped');
    defaultApi.writeLog(`sdk action : stopPullFlow ,userId : ${userId}, groupId: ${groupId}, notice: stream_stopped`);
  },

  /**
   * @function 暂停拉所有的流
   * @return Promise | void
   */
  async stopAllPullFlow() {
    defaultApi.writeLog('sdk action : stopAllPullFlow begin');
    reporter.userFunc('stopAllPullFlow');
    await zbztAVSDK.stopAllPullFlow();
    defaultApi.writeLog('sdk action : stopAllPullFlow end');
  },

  async playDestroy(userId, groupId) {
    if (typeof userId !== 'number' && typeof userId !== 'string') {
      defaultApi.writeLog(`sdk action : playDestroy ,userId : ${userId}, groupId: ${groupId}, param error`);
      return;
    } else {
      defaultApi.writeLog(`sdk action : playDestroy ,userId : ${userId}, groupId: ${groupId}, begin`);
    }
    const streamId = generateStreamId(userId, groupId);
    await zbztAVSDK.playDestroy(streamId);
    noticeStreamStatus(userId, 'stream_destroy');
    defaultApi.writeLog(`sdk action : playDestroy ,userId : ${userId}, groupId: ${groupId}, notice: stream_destroy`);
  },

  async changePullFlow(args) {
    defaultApi.writeLog(`sdk action : changePullFlow ,${JSON.stringify(args)}`);
    const streamId = generateStreamId(args.userId, args.groupId);
    const toStreamId = generateStreamId(args.toUserId, args.toGroupId);
    const result = zbztAVSDK.changePullFlow({
      toDomId: args.toDomId,
      streamId,
      toStreamId
    });
    const {
      videoSrc,
      playerId
    } = await result;
    defaultApi.writeLog(`sdk changePullFlow ${JSON.stringify(args)}, streamId : ${streamId}, toStreamId : ${toStreamId}, result :${result.sdk_type}: ${videoSrc}`);
    if (args.needPlayerId) {
      return {
        videoSrc,
        playerId
      };
    }
    return videoSrc;
  },

  async getSpeakerDeviceList() {
    defaultApi.writeLog('sdk action : getSpeakerDeviceList');
    reporter.userFunc('getSpeakerDeviceList');
    const devices = await zbztAVSDK.getSpeakerDeviceList();
    defaultApi.writeLog(`sdk action : getSpeakerDeviceList ${JSON.stringify(devices)}`);
    reporter.userFunc('getSpeakerDeviceList', devices);
    return devices;
  },

  async setSpeakerDevice(deviceId) {
    defaultApi.writeLog(`sdk action : setSpeakerDevice deviceId:${deviceId}`);
    reporter.userFunc('setSpeakerDevice', deviceId);
    await zbztAVSDK.setSpeakerDevice(deviceId, 'client');
  },

  async getSpeakerDevice() {
    defaultApi.writeLog('sdk action : getSpeakerDevice');
    return zbztAVSDK.getSpeakerDevice();
  },

  async getSpeakerVolume() {
    defaultApi.writeLog('sdk action : getSpeakerVolume ');
    return await zbztAVSDK.getSpeakerVolume();
  },

  async setSpeakerVolume(volume) {
    await zbztAVSDK.setSpeakerVolume(volume);
    defaultApi.writeLog(`sdk action : setSpeakerVolume ${volume}`);

  },

  async setSpeakerMute(mute) {
    await zbztAVSDK.setSpeakerMute(mute);
    try {
      dataReport.deviceChange({
        device_type: 3,
        code: mute ? 0 :1,
        device_name: window.zbztAVSDK_device_checker_init.speaker.name,
        device_id: window.zbztAVSDK_device_checker_init.speaker.use
      });
    } catch (e){};
    defaultApi.writeLog(`sdk action : setSpeakerMute ${mute}`);
  },

  async openOrCloseCameraAndMicrophone(type) {
    await zbztAVSDK.openOrCloseCameraAndMicrophone(type);
    defaultApi.writeLog(`sdk action : openOrCloseCameraAndMicrophone ${type}`);
  },

  async getAppVolume() {
    const volume = await zbztAVSDK.getAppVolume();
    defaultApi.writeLog(`sdk action : getAppVolume ${volume}`);
    return volume;
  },

  async setAppVolume(volume) {
    await zbztAVSDK.setAppVolume(volume);
    defaultApi.writeLog(`sdk action : setAppVolume ${volume}`);

  },

  async setAppMute(mute) {
    await zbztAVSDK.setAppMute(mute);
    defaultApi.writeLog(`sdk action : setAppMute ${mute}`);
  },

  async getMicrophoneDeviceList() {
    defaultApi.writeLog('sdk action : getMicrophoneDeviceList');
    reporter.userFunc('getMicrophoneDeviceList');
    const devices = await zbztAVSDK.getMicrophoneDeviceList();
    defaultApi.writeLog(`sdk action : getMicrophoneDeviceList ${JSON.stringify(devices)}`);
    reporter.userFunc('getMicrophoneDeviceList', devices);
    return devices;
  },

  async setMicrophoneDevice(deviceId) {
    defaultApi.writeLog(`sdk action : setMicrophoneDevice ${deviceId}`);
    reporter.userFunc('setMicrophoneDevice', deviceId);
    await zbztAVSDK.setMicrophoneDevice(deviceId, 'client');
  },

  async openOrCloseMicrophone(operation) {
    defaultApi.writeLog(`sdk action : openOrCloseMicrophone ${operation} --start`);
    reporter.userFunc('openOrCloseMicrophone', operation);
    userAndDeviceStatusInfo.microPhone = operation;
    //记录麦克风状态，用作推流类型上报，是否推声音
    this.deviceStatus.microphone = operation;
    try {
      await zbztAVSDK.openOrCloseMicrophone(operation);
    } catch (error) {
      defaultApi.writeLog(`sdk action : openOrCloseMicrophone ${error}`, null, 'error');
      if (operation) {
        NOTICE.openMicphoneError(error);
      }
      return;
    }
    try {
      dataReport.deviceChange({
        device_type: 2,
        code: operation ? 1 : 0,
        device_name: window.zbztAVSDK_device_checker_init.microphone.name,
        device_id: window.zbztAVSDK_device_checker_init.microphone.use
      });
    } catch (e){};
    sdk_status === 1 && sendDeviceStatus('audio', operation);
    defaultApi.writeLog(`sdk action : openOrCloseMicrophone ${operation} --end`);

  },

  //听或不听指定用户的声音
  async setAudioMute(userId, mute, groupId, streamid) {
    defaultApi.writeLog(`sdk action : setAudioMute userId ${userId}, mute ${mute}, groupId ${groupId}, streamid ${streamid}`);
    reporter.userFunc('setAudioMute', {userId, mute, groupId, streamid});
    const streamId = streamid || generateStreamId(userId, groupId);
    await zbztAVSDK.setAudioMute(streamId, mute);
  },

  /**
   * @function 是否拉取音频流--通过播放器id控制
   * @param operation:Boolean，必选，true | false
   * @param playerId:Number，必选，播放器id
   * @return Promise | void
   */
  async pullAudioFlow(streamid, operation) {
    defaultApi.writeLog(`sdk action : pullAudioFlow --start ${operation}, streamid ${streamid}`);
    reporter.userFunc('pullAudioFlow', {streamid, operation});
    await zbztAVSDK.pullAudioFlow(streamid, operation);
    defaultApi.writeLog(`sdk action : pullAudioFlow --end ${operation}, streamid ${streamid}`);

  },

  async getMicrophoneVolume() {
    defaultApi.writeLog('sdk action : getMicrophoneVolume');
    return await zbztAVSDK.getMicrophoneVolume();
  },

  async setMicrophoneVolume(volume, mute) {
    defaultApi.writeLog(`sdk action : setMicrophoneVolume ${volume} ${mute}`);
    reporter.userFunc('setMicrophoneVolume', {volume, mute});
    await zbztAVSDK.setMicrophoneVolume(volume, mute);
  },

  async setMicrophoneMute(mute) {
    await zbztAVSDK.setMicrophoneMute(mute);
    defaultApi.writeLog(`sdk action : setMicrophoneMute ${mute}`);
  },

  async leaveRoom(type) {
    //未初始化完成，无须卸载
    // if (sdk_status === -1) {
    //   zbztsdk.notice({
    //     type: 'error',
    //     data: {
    //       message: 'should not leaveRoom before init finished'
    //     }
    //   });
    //   return;
    // }
    defaultApi.writeLog('sdk action : leaveRoom');
    reporter.userFunc('leaveRoom');
    // if (window.zbzt_sdk_init_params.role === 'student') {
    CHANNEL.sendRemoveStream(window.zbzt_sdk_init_params);
    // }
    CHANNEL.sendLeave(window.zbzt_sdk_init_params);
    CHANNEL.leaveRoom();
    // 重置设备检测初始化状态
    await zbztAVSDK.leaveRoom(type);

    windowObjArr[0].concat(windowObjArr[1]).forEach(item => {
      localStorage.removeItem(item);
    });

    sdk_status = -1;
    try {
      dataReport.leaveRoom();
    } catch (e) {};
    defaultApi.writeLog('sdk leaveRoom end ,sdk status : uninstall_finished');
    //通知业务层，卸载完成
    NOTICE.sdkStatus({
      sdk_type: window.zbztAVSDK_init_sdk_type,
      status: 'uninstall_finished'
    });
    window.zbztAVSDK_device_checker_init = null;
  },

  //崩溃后的销毁引擎,反初始化
  async deinit() {
    defaultApi.writeLog('sdk action : deinit');
    await zbztAVSDK.deinit();
  },

  /**
   * @function 转推，录课
   * @param type:String 动作类型，必选，'start' | 'stop' | 'pause' | 'resume'
   * @return Promise | void
   */
  async turnPush(cmd) {
    await zbztAVSDK.turnPush(cmd);
    defaultApi.writeLog(`sdk action : turnPush  ${cmd}`);
  },

  openMicVolumeCb(open) {
    zbztAVSDK.openMicVolumeCb(open);
    defaultApi.writeLog(`sdk action : openMicVolumeCb  ${open}`);
  },

  mixedstuVideo(stuArray) {
    zbztAVSDK.mixedstuVideo(stuArray);
    defaultApi.writeLog(`sdk action : mixedstuVideo, stuArray:  ${stuArray}`);
  },

  /**
   * @function 单路流录制
   * @param  args:Object
   * {
   *  type: String，必选，'start' | 'stop'
   *  groupId: String, 可选，分组id
   *  userId: String, 可选，用户id
   * }
   */
  singleRecord(args) {
    args.streamId = this.getStreamInfo(args.userId, args.groupId).streamId;
    zbztAVSDK.singleRecord(args);
    defaultApi.writeLog(`sdk action : singleRecord, args:  ${JSON.stringify(args)}`);
  },
  //开启拉流音量监听
  startSoundLevelMonitor() {
    defaultApi.writeLog('sdk action : startSoundLevelMonitor --start');
    zbztAVSDK.startSoundLevelMonitor();
    defaultApi.writeLog('sdk action : startSoundLevelMonitor --end');
  },
  /**
   * @function 多路转推
   * @param  args:Object
   * {
   *  type: String，必选，'start' | 'stop'
   *  groupId: String, 可选，分组id
   *  userId: String, 可选，用户id
   * }
   */
  async recordPublish(args) {
    args.streamId = this.getStreamInfo(args.userId, args.groupId).streamId;
    zbztAVSDK.recordPublishTarget(args);
    defaultApi.writeLog(`sdk action : recordPublish, args:  ${JSON.stringify(args)}`);
  },

  /**
   * @function 获取视频快照截图所需的 id 数据
   * @param  userId:String 用户 ID
   * @param  roomId:String 房间 ID
   */
  getStreamInfo(userId, roomId) {
    const streamId = generateStreamId(userId, roomId);
    defaultApi.writeLog(`sdk action :getStreamInfo --start, userId : ${userId}, roomId: ${roomId}`);
    if (!userId || userId == window.zbzt_sdk_init_params.userId) {
      switch (window.current_sdk_type) {
      case 'rtc':
        try{
          dataReport.takeSnapShot({snapshootId:streamId});
        }catch(e){}
        return {
          streamId,
          snapshootId: streamId
        };
        break;
      case 'zego':
        try{
          dataReport.takeSnapShot({getStreamInfoZego:streamId,snapshootId:-1});
        }catch(e){}
        return {
          streamId,
          snapshootId: -1
        };
        break;
      case 'nertc':
      case 'volcrtc':
      case 'talrtc':
        try {
          dataReport.takeSnapShot({snapshootId:streamId});
        } catch (e) {}
        return {
          streamId,
          snapshootId: -2
        };
      case 'trtc':
        try {
          dataReport.takeSnapShot({snapshootId:streamId});
        } catch (e) {}
        return {
          streamId,
          snapshootId: -3
        };
      default:
        break;
      }
    }
    let snapshootId = zbztAVSDK.getSnapshootId(streamId);
    defaultApi.writeLog(`sdk action :getStreamInfo, userId : ${userId}, snapshootId: ${snapshootId}`);
    return {
      streamId,
      snapshootId
    };
  },

  getAllChannelIndex() {
    let channelMap = zbztAVSDK.getAllChannelIndex();
    return channelMap;
  },

  /**
   * @function 记录日志
   * @param productName:String 产品名称，必选
   * @param type:String 日志类型，可选，default : 'info',  'debug' | 'info' | 'warnning' | 'error' | 'critical'，
   * @param content:String | Object 日志记录主要内容
   */
  log(productName, content, type = 'info') {
    if (!productName) {
      defaultApi.writeLog('sdk action :log methods invoked error, no productName');
      return;
    }
    defaultApi.writeLog(content, productName, type);
  },
  /**
   * @function 设置摄像头参数
   * @param width:Number 分辨率宽，必选，推荐 1280
   * @param height:Number 分辨率高，必选，推荐 720
   * @param frameRate:Number 帧率，必选，推荐 15
   * @return Promise | void
   */
  setCameraParams(args) {
    defaultApi.writeLog(`sdk action: setCameraParam, args: ${JSON.stringify(args)}`);
    return zbztAVSDK.setCameraParams(args);
  },

  setEncodeParams(args) {
    defaultApi.writeLog(`sdk action: setEncodeParams, args: ${JSON.stringify(args)}`);
    return zbztAVSDK.setEncodeParams(args);
  },

  setBitRate(bitrate) {
    defaultApi.writeLog(`sdk action: setBitRate, bitrate: ${bitrate}`);
    return zbztAVSDK.setBitRate(bitrate);
  },

  /**
  * @function 本地视频录制
  * @param type 开始/结束
  * @param path 录制路径
  * @return Promise | void
  */
  localRecordVideo(type, path) {
    defaultApi.writeLog(`sdk action: localRecordVideo, type: ${type}, path ${path}`);
    return zbztAVSDK.localRecordVideo(type, path);
  },
  /**
  * @function 本地音频录制
  * @param type 开始/结束
  * @param path 录制路径
  * @return Promise | void
  */
  localRecordAudio(type, path) {
    defaultApi.writeLog(`sdk action: localRecordAudio, type: ${type}, path ${path}`);
    return zbztAVSDK.localRecordAudio(type, path);
  },
  /**
   * @function 开始连麦
   * @param mode:number 采集器默认， 默认0=站立 1=坐立
   * @return Promise | void
   */
  async teacherStartLinkMic(mode) {
    defaultApi.writeLog(`sdk action: teacherStartLinkMic, mode: ${mode}`);
    try {
      dataReport.avConnect({
        sdk_type: window.zbztAVSDK_init_sdk_type,
        type: 1,
        mode
      });
    } catch (e) {};
    await zbztAVSDK.teacherStartLinkMic(mode);
    // if (mode === 0) {
    //   await zbztAVSDK.startPreview();
    // }
    return this.startPushFlow();
  },
  /**
   * @function 结束连麦
   * @param mode:number 采集器默认， 默认0=站立 1=坐立
   * @return Promise | void
   */
  async teacherStopLinkMic(mode) {
    defaultApi.writeLog(`sdk action: teacherStopLinkMic, mode: ${mode}`);
    try {
      dataReport.avConnect({
        sdk_type: window.zbztAVSDK_init_sdk_type,
        type: 0,
        mode
      });
    } catch (e) {};
    await zbztAVSDK.teacherStopLinkMic(mode);
    if (mode === 0) {
      await zbztAVSDK.stopPreview();
    }
    return this.stopPushFlow();
  },
  getSdkStatus() {
    return sdk_status;
  },
  // 获取截屏窗位置
  //设置采集扬声器声音
  setSpeakerCapture(deviceId, speaker){
    defaultApi.writeLog(`sdk action: setSpeakerCapture, deviceId: ${deviceId}, speaker: ${speaker}`);
    return zbztAVSDK.setSpeakerCapture(deviceId, speaker);
  },
  /**
    * @function 设置混流和背景色
    * @param { number }  type  0=不拼接/1=截屏窗+背景图/2=截屏窗+背景图+头像
    * @param { number } id 需要混合的采集器id
    * @param { object } rgb
    * @param { number } rgb.r
    * @param { number } rgb.g
    * @param { number } rgb.b
    * @return: Promise
    */
  setMixStream(type, id, rgb) {
    defaultApi.writeLog(`sdk action: setMixStream, type: ${type}, id: ${id}, rgb: ${JSON.stringify(rgb)}`);
    return zbztAVSDK.setMixStream(type, id, rgb);
  },
  /**
    * @function 采集器截图
    * @param { string } fileName 文件名，需要后缀名。例如：333.jpg
    * @return: Promise
    */
  captureSnapShot(fileName) {
    defaultApi.writeLog(`sdk action: captureSnapShot, fileName: ${fileName}`);
    return zbztAVSDK.captureSnapShot(fileName);
  },
  /**
    * @function 播放器截图
    * @param { string } streamId 播放器id
    * @param { string } fileName 文件名，需要后缀名。例如：333.jpg
    * @return { Promise<ImageData> }
    */
  playerSnapShot(streamId, fileName) {
    defaultApi.writeLog(`sdk action: playerSnapShot, id: ${streamId} fileName: ${fileName}`);
    reporter.userFunc('playerSnapShot', {streamId, fileName});
    return zbztAVSDK.playerSnapShot(streamId, fileName);
  },

  /**
  * @function 设置预览镜像状态
  * @param { boolean } type true=开启 false=关闭
  * @return: Promise
  */
  setMirrorStatus(type) {
    defaultApi.writeLog(`sdk action: setMirrorStatus, type: ${type}`);
    if (type !== undefined && type !== null) {
      mirrorStatus = type;
    }
    return zbztAVSDK.setMirrorStatus(type);
  },
  /**
  * @function 设置拉流镜像状态
  * @param { boolean } type true=开启 false=关闭
  * @return: Promise
  */
  setPlayViewMirror(type, id) {
    defaultApi.writeLog(`sdk action: setPlayViewMirror, type: ${type}, id: ${id}`);
    return zbztAVSDK.setPlayViewMirror(type, id);
  },

  /**
  * @function 设置推流镜像状态
  * @param { boolean } id 采集器Id
  * @param { boolean } mode 1=开启 0=关闭
  * @return: Promise
  */
  setPushViewMirror(mode) {
    defaultApi.writeLog(`sdk action: setPushViewMirror, mode: ${mode}`);
    if (mode !== undefined && mode !== null) {
      mirrorStatus = mode;
    }
    return zbztAVSDK.setPushViewMirror(mode);
  },

  /**
  * @function zego40路拉流混音接口
  * @param { number } mixMode //混流模式  0=关闭混流  1=开启混流
  * @param { array } userIdArr //要突出声音的userId的数组集合
  * @return: Promise
  */
  setAudioMixMode(mixMode, userIdArr) {
    let streamIdArr = [];
    if(userIdArr.length > 0) {
      userIdArr.forEach(item => {
        streamIdArr.push(generateStreamId(item));
      });
    }
    defaultApi.writeLog(`sdk action: setAudioMixMode mixMode:${mixMode} userIdArr:${userIdArr} streamIdArr:${streamIdArr}`);
    return zbztAVSDK.setAudioMixMode(mixMode, streamIdArr);
  },

  //获取TalMedia.dll版本号&&获取zegoAvkit.dll版本号
  getSDKVersion() {
    defaultApi.writeLog('sdk action: getSDKVersion');
    return zbztAVSDK.getSDKVersion();
  },

  //获取摄像头所支持的分辨率
  getCameraSupportedResolution(deviceId) {
    defaultApi.writeLog(`sdk action: getCameraSupportedResolution deviceId: ${deviceId}`);
    return zbztAVSDK.getCameraSupportedResolution(deviceId);
  },
  //开启rtc同屏
  startMultiScreen() {
    defaultApi.writeLog('sdk action: startMultiScreen');
    return zbztAVSDK.startMultiScreen();
  },
  //开启高光时刻
  startHighlight(enable) {
    defaultApi.writeLog(`sdk action: startHighlight enable:${enable}`);
    return zbztAVSDK.enableHighlight(enable);
  },
  //开启外部音频采集
  startAudioExCapture() {
    defaultApi.writeLog('sdk action: startAudioExCapture');
    return zbztAVSDK.startAudioExCapture();
  },

  //RTC同屏 辅助通道音频类型
  setAUXAudioType(type) {
    defaultApi.writeLog('sdk action: setAUXAudioType');
    return zbztAVSDK.setAUXAudioType(type);
  },

  //RTC同屏 录制通道音频类型
  setThirdAudioType(type) {
    defaultApi.writeLog('sdk action: setThirdAudioType');
    return zbztAVSDK.setThirdAudioType(type);
  },
  

  //发送sei
  sendMediaSideInfo(info) {
    defaultApi.writeLog('sdk action: sendMediaSideInfo');
    return zbztAVSDK.sendMediaSideInfo(info);
  },

  /**
 * @function 开始录制
 * @param {number} 录制文件类型 可选，默认mp4 
 * @param {number} 录制文件名称 可选
 * @returns {Promise<any>}
 */
  async startCaptureRecord(fileType = 2, fileName, idx = 2) {
    defaultApi.writeLog(`sdk action: startCaptureRecord fileType:${fileType} fileName:${fileName} idx:${idx}`);
    // 格式化fileType
    fileType = Number(fileType);
    if(fileType !== 1 && fileType !== 2){
      fileType = 2;
    }
    // 格式化idx
    if (idx !==0 && idx !== 1 && idx !== 2) {
      idx = 2;
    }
    const result = await zbztAVSDK.startRecord(fileName, fileType, idx);
    await zbztAVSDK.startCapture(idx);
    return result;
  },
  /**
   * @function 结束录制
   * @param {number} 录制推流通道 idx 必选
   * @return: Promise
   */
  async stopCaptureRecord(idx = 2) {
    await zbztAVSDK.stopRecord(idx);
    return zbztAVSDK.stopCapture(idx);
  },
  /**
    * @function 切换sdk类型
    * @return: Promise
  */
  // async changeSdkType(institutionId, sdkName, roomId) {
  //   defaultApi.writeLog(`sdk action: changeSdkType, institutionId: ${institutionId}, sdkName: ${sdkName}, roomId: ${roomId}`);
  //   let code;
  //   let param = {
  //     institutionId,
  //     sdkName,
  //     roomId,
  //     workCode:0
  //   };
  //   let res = await changeSdkInRoom(param);
  //   defaultApi.writeLog(`sdk action: changeSdkType, sdk切换${res.code == 0 ? '成功' : '失败'}, ${JSON.stringify(res)}`);
  //   code = res.code == 0 ? 0 : 1; //0切换成功 ,1切换失败
  //   return code ;
  // },
  async changeSdkType(institutionId, sdkName, teacherId, liveId) {
    defaultApi.writeLog(`sdk action: changeSdkType, institutionId: ${institutionId}, sdkName: ${sdkName}, teacherId: ${teacherId}, liveId: ${liveId}`);
    let code;
    let param = {
      institutionId,
      sdkName,
      lectureStreamId:`lecturer_${teacherId}_${liveId}`,
      workCode:0
    };
    let res = await changeSdkInRoom(param);
    defaultApi.writeLog(`sdk action: changeSdkType, sdk切换${res.code == 0 ? '成功' : '失败'}, ${JSON.stringify(res)}`);
    code = res.code == 0 ? 0 : 1; //0切换成功 ,1切换失败
    return code ;
  },

  /**
   * 开始cdn录制
   * @param {object} args
   * @param {string} args.streamId
   * @param {string} args.taskID
   * @param {string} args.url
   * @returns 
   */
  async startCDNRecord(args) {
    defaultApi.writeLog(`sdk action: startCDNRecord, args: ${JSON.stringify(args)}`);
    return zbztAVSDK.startCDNRecord(args);
  },
  /**
   * 停止cdn录制
   * @param {string} taskID 
   * @returns 
   */
  async stopCDNRecord(taskID) {
    defaultApi.writeLog(`sdk action: stopCDNRecord, taskID: ${taskID}`);
    return zbztAVSDK.stopCDNRecord(taskID);
  },
};

window.zbztsdk = zbztsdk;

export default zbztsdk;
